"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _Thumbnail = _interopRequireDefault(require("./_Thumbnail"));
var _styles = require("./styles");
var _propTypes2 = require("./_propTypes");
var _ThumbnailSkeletons = _interopRequireDefault(require("./ThumbnailSkeletons"));
var _Hideable = _interopRequireDefault(require("../Hideable"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Thumbnails = function Thumbnails(_ref) {
  var mediaImages = _ref.mediaImages,
    activeIndex = _ref.activeIndex,
    max = _ref.max,
    onThumbnailClick = _ref.onThumbnailClick,
    onThumbnailHover = _ref.onThumbnailHover,
    onImageLoaded = _ref.onImageLoaded,
    onImageRequested = _ref.onImageRequested,
    visualizerImagesLoaded = _ref.visualizerImagesLoaded,
    responsiveImageHelper = _ref.responsiveImageHelper,
    useSkeletons = _ref.useSkeletons,
    formatThumbnailAriaLabel = _ref.formatThumbnailAriaLabel;
  var formatThumbnailAriaLabelFun = formatThumbnailAriaLabel;
  if (formatThumbnailAriaLabel === _noop["default"]) {
    formatThumbnailAriaLabelFun = function formatThumbnailAriaLabelFun(index, count, maxViewable, mediaType) {
      if (index >= maxViewable && mediaType !== '') {
        return 'More product images';
      }
      return "Product Image ".concat(index, " of ").concat(count);
    };
  }
  var count = mediaImages.length;
  return /*#__PURE__*/_react["default"].createElement(_styles.ThumbnailList, null, useSkeletons && /*#__PURE__*/_react["default"].createElement(_Hideable["default"], {
    isHidden: visualizerImagesLoaded
  }, /*#__PURE__*/_react["default"].createElement(_ThumbnailSkeletons["default"], null)), /*#__PURE__*/_react["default"].createElement(_Hideable["default"], {
    isHidden: useSkeletons && !visualizerImagesLoaded
  }, mediaImages.map(function (image, index) {
    // for desktop, cut off at max and add a "+X" overlay on the last one
    if (max > 0 && index >= max) {
      return null;
    }
    var showRemaining = max > 0 && mediaImages.length > max && index === max - 1;
    var remaining = showRemaining ? mediaImages.length - (max - 1) : -1;
    var imageName = "thumbnail ".concat(index);
    (0, _react.useEffect)(function () {
      onImageRequested(imageName);
    }, []);
    var _ref2 = responsiveImageHelper ? responsiveImageHelper.thumbnail(image.thumbnail) : {},
      srcSet = _ref2.srcSet,
      sizes = _ref2.sizes;
    return /*#__PURE__*/_react["default"].createElement(_Thumbnail["default"], {
      key: image.thumbnail && image.thumbnail !== 'data:;' ? image.thumbnail : index,
      src: image.thumbnail,
      srcSet: srcSet,
      sizes: sizes,
      mediaType: image.mediaType,
      caption: image.caption,
      selected: index === activeIndex,
      remaining: remaining,
      onClick: function onClick() {
        return onThumbnailClick(index);
      },
      onMouseEnter: function onMouseEnter() {
        return onThumbnailHover(index);
      },
      onFocus: function onFocus() {
        onThumbnailHover(index);
      },
      onImageLoaded: onImageLoaded(imageName),
      ariaLabel: formatThumbnailAriaLabelFun(index + 1, count, max, image.mediaType)
    });
  }).filter(function (i) {
    return i;
  })));
};
Thumbnails.propTypes = {
  onThumbnailClick: _propTypes["default"].func.isRequired,
  onThumbnailHover: _propTypes["default"].func.isRequired,
  mediaImages: _propTypes["default"].arrayOf(_propTypes2.mediaImageShape).isRequired,
  activeIndex: _propTypes["default"].number.isRequired,
  max: _propTypes["default"].number.isRequired,
  onImageLoaded: _propTypes["default"].func,
  onImageRequested: _propTypes["default"].func,
  visualizerImagesLoaded: _propTypes["default"].bool,
  responsiveImageHelper: _propTypes["default"].shape({
    thumbnail: _propTypes["default"].func
  }),
  useSkeletons: _propTypes["default"].bool,
  formatThumbnailAriaLabel: _propTypes["default"].func
};
Thumbnails.defaultProps = {
  onImageLoaded: _noop["default"],
  onImageRequested: _noop["default"],
  visualizerImagesLoaded: false,
  responsiveImageHelper: undefined,
  useSkeletons: false,
  formatThumbnailAriaLabel: _noop["default"]
};
var _default = Thumbnails;
exports["default"] = _default;
//# sourceMappingURL=_Thumbnails.js.map